/** Build/runtime config for the SPA. VITE_* vars come from apphosting.yaml (BUILD). */

export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? "";

/** Opt in to hitting the local Functions emulator instead of DEV mocks. */
export const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === "true";

/**
 * In dev we default to mocked backend calls so the UI runs standalone (no
 * emulator, no App Check). Set VITE_USE_EMULATORS=true to exercise the real
 * callables against the Firebase emulator. Production always uses real calls.
 */
export const USE_MOCKS = import.meta.env.DEV && !USE_EMULATORS;

/** Carried on the WH-1 payload; bump when the click-through ToS changes. */
export const TOS_VERSION = "gen-tos-2026-07";

/** Terms the customer affirms at the e-sign consent step. Open in a new tab. */
export const TOS_URL = "https://kasselmansolar.com/terms-of-service/";
export const PRIVACY_URL = "https://kasselmansolar.com/privacy-policy-2026/";

export const SUBMISSION_SOURCE = {
  site: "kasselmansolar.com",
  page: "/generators",
  embed: "iframe-v1",
} as const;

/**
 * Google Maps browser key (#44). Public by nature — the control is the HTTP-referrer
 * restriction on the key, not secrecy. The SAME key has Maps JavaScript API + Geocoding
 * API enabled. Empty in dev until set; the map component fails open to a placeholder.
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "";

/**
 * Map ID for AdvancedMarkerElement (required by the marker library). Create one in
 * Cloud console → Map Management, or use the built-in "DEMO_MAP_ID" dev fallback.
 */
export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID ?? "DEMO_MAP_ID";
